import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronDown, Phone, Mail } from 'lucide-react';
import { faInstagram , faFacebookF , faYoutube } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logo from "../assets/image0.png";
import news from "../assets/new.gif";
import InquiryForm from '../pages/InquiryForm';
import '../styles/Navbar.css';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [activeNested, setActiveNested] = useState(null);
  const [isEnquiryOpen, setIsEnquiryOpen] = useState(false);

  // ✅ Sirf backend se announcements
  const [announcements, setAnnouncements] = useState([]);

  const toggleMenu = () => setIsOpen(!isOpen);

  useEffect(() => {
    fetch('/api/announcements')
      .then((res) => res.json())
      .then((data) => {
        if (data && data.length > 0) {
          const formatted = data.map((item) => {
            const date = new Date(item.date).toLocaleDateString('en-GB', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            }).replace(/\//g, '-');
            return `${date} ${item.title}`;
          });
          setAnnouncements(formatted);
        }
      })
      .catch((err) => console.log('Backend error:', err));
  }, []);

  const menuItems = [
    { label: 'Home', path: '/', page: 'home' },
    {
      label: 'About',
      page: 'about',
      submenu: [
        { label: 'Who We Are', path: '/vision' },
        { label: 'Sister Concern', path: '/sister' },
        { 
          label: 'Leadership', 
          submenu: [
            { label: "Chairman's Desk", path: '/chairman' },
            { label: "Secretary's Desk", path: '/secretary' },
            { label: "Principal's Desk", path: '/principal' }
          ]
        }
      ]
    },
    {
      label: 'Facilities',
      page: 'academics',
      submenu: [
        { label: 'Commerce', path: '/commerse' },
        { label: 'Arts', path: '/arts' },
        { label: 'Agriculture', path: '/agri' },
        { label: 'Canteen', path: '/canteen' },
        { label: 'Hostel', path: '/hostel' },
        { label: 'Laboratories', path: '/Laboratory' },
        { label: 'Arts and Craft', path: '/artandcraft' },
        { label: 'Library', path: '/library' },
      ]
    },
    {
      label: 'Faculty',
      page: 'faculty',
      submenu: [
        { label: 'Teaching Staff', path: '/teaching' },
        { label: 'Non-Teaching Staff', path: '/nonteaching' }
      ]
    },
    { label: 'Admission', path: '/admission', page: 'admission' },
    { label: 'Gallery', path: '/gallery', page: 'gallery' },
    { label: 'Contact', path: '/contact', page: 'contact' }
  ];

  const handleMenuClick = () => {
    setIsOpen(false);
    setActiveDropdown(null);
    setActiveNested(null);
  };

  const handleEnquiryClick = (e) => {
    e.preventDefault();
    setIsEnquiryOpen(true);
    setIsOpen(false);
  };

  const toggleNested = (idx, subidx) => {
    if (activeNested === `${idx}-${subidx}`) {
      setActiveNested(null);
    } else {
      setActiveNested(`${idx}-${subidx}`);
    }
  };

  return (
    <>
     {/* TOP BAR */}
        <div className="bca-top-bar">
          <div className="bca-top-bar-content">
            <div className="bca-contact-info">
              <a href="tel:0154- 2460807">
                <Phone size={16} /> +01542466778
              </a>
              <a href="mailto:bihanischool@yahoo.in">
                <Mail size={16} />bihanischool@yahoo.in
              </a>
            </div>
             <div className="bca-social-icons">
                      <a className="social-icon insta" href="https://www.instagram.com/sdbihanischoolsgnr/" aria-label="Instagram">
                        <FontAwesomeIcon icon={faInstagram} />
                      </a>
                      <a className="social-icon facebook" href="https://www.facebook.com/sdbihanischoolsgnr/" aria-label="Facebook">
                        <FontAwesomeIcon icon={faFacebookF} />
                      </a>
                      <a className="social-icon youtube" href="https://www.youtube.com/@Bihanishikshatrustsgnr" aria-label="YouTube">
                        <FontAwesomeIcon icon={faYoutube} />
                      </a>
                    </div>
          </div>
        </div>

      {/* Main Navbar */}
      <nav className="navbar">
        <div className="nav-container">
          {/* Logo */}
          <Link to="/" className="logo-section" onClick={handleMenuClick}>
            <div className="logo-badge">
              <img src={logo} alt="" className="logo-svg"/>
            </div>
            <div className="school-info">
              <div className="school-name-wrapper">
                <h1 className="school-name">SETH. G.L BIHANI S.D. SR. SEC. SCHOOL</h1>
              </div>
              <p className="school-location">National Highway 62 SriGanganagar (Rajasthan)</p>
            </div>
          </Link>

          {/* Desktop Menu */}
          <div className="desktop-menu">
            {menuItems.map((item, idx) => (
              <div key={idx} className="menu-item-wrapper">
                <Link to={item.path} className="menu-link">
                  {item.label}
                  {item.submenu && <ChevronDown size={16} className="chevron-icon" />}
                </Link>

                {item.submenu && (
                  <div className="dropdown-menu">
                    {item.submenu.map((subitem, subidx) => (
                      <div key={subidx} className="menu-item-wrapper">
                        <Link to={subitem.path} className="dropdown-item">
                          {subitem.label}
                          {subitem.submenu && <ChevronDown size={14} className="chevron-icon" />}
                        </Link>
                        
                        {subitem.submenu && (
                          <div className="nested-dropdown-menu">
                            {subitem.submenu.map((nesteditem, nestedidx) => (
                              <Link
                                key={nestedidx}
                                to={nesteditem.path}
                                className="nested-dropdown-item"
                              >
                                {nesteditem.label}
                              </Link>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Enquiry Button - Desktop */}
          <button className="enquiry-btn" onClick={handleEnquiryClick}>
            Enquiry
          </button>

          {/* Mobile Menu Button */}
          <button onClick={toggleMenu} className="mobile-menu-toggle">
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="mobile-menu">
            {menuItems.map((item, idx) => (
              <div key={idx}>
                {item.submenu ? (
                  <button
                    onClick={() => setActiveDropdown(activeDropdown === idx ? null : idx)}
                    className="mobile-menu-item mobile-menu-item-dropdown"
                  >
                    <span>{item.label}</span>
                    <ChevronDown
                      size={16}
                      className={`chevron-icon ${activeDropdown === idx ? 'rotate' : ''}`}
                    />
                  </button>
                ) : (
                  <Link
                    to={item.path}
                    onClick={() => handleMenuClick()}
                    className="mobile-menu-item"
                  >
                    <span>{item.label}</span>
                  </Link>
                )}

                {item.submenu && activeDropdown === idx && (
                  <div className="mobile-dropdown-menu">
                    {item.submenu.map((subitem, subidx) => (
                      <div key={subidx}>
                        {subitem.submenu ? (
                          <div>
                            <button
                              onClick={() => toggleNested(idx, subidx)}
                              className="mobile-dropdown-item mobile-nested-toggle"
                            >
                              <span>{subitem.label}</span>
                              <ChevronDown
                                size={14}
                                className={`chevron-icon ${activeNested === `${idx}-${subidx}` ? 'rotate' : ''}`}
                              />
                            </button>
                            
                            {activeNested === `${idx}-${subidx}` && (
                              <div className="mobile-nested-dropdown-menu">
                                {subitem.submenu.map((nesteditem, nestedidx) => (
                                  <Link
                                    key={nestedidx}
                                    to={nesteditem.path}
                                    onClick={() => handleMenuClick()}
                                    className="mobile-nested-dropdown-item"
                                  >
                                    {nesteditem.label}
                                  </Link>
                                ))}
                              </div>
                            )}
                          </div>
                        ) : (
                          <Link
                            to={subitem.path}
                            onClick={() => handleMenuClick()}
                            className="mobile-dropdown-item"
                          >
                            {subitem.label}
                          </Link>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
            <button className="enquiry-btn-mobile" onClick={handleEnquiryClick}>
              Enquiry
            </button>
          </div>
        )}
      </nav>

      {/* ✅ Announcement Banner - Backend se data */}
      <div className="announcement-banner">
        <div className="announcement-content">
          <div className="marquee-wrapper">
            <div className="marquee">
              {announcements.map((announcement, idx) => (
                <span key={idx}>
                  <img src={news} alt="" className='imgmarque'/> {announcement}
                </span>
              ))}
              {announcements.map((announcement, idx) => (
                <span key={`repeat-${idx}`}>
                  <img src={news} alt="" className='imgmarque'/> {announcement}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Inquiry Form Modal */}
      <InquiryForm 
        isOpen={isEnquiryOpen} 
        onClose={() => setIsEnquiryOpen(false)} 
      />
    </>
  );
}